export default "__VITE_ASSET__D83aHW_H__"